import React, { useState } from 'react';
import { Group, SegmentedControl } from '@mantine/core';

import type { MasterEntityType } from '@api/entity-attributes';

import EntityMasterTab from './EntityMasterTab';

/**
 * The same shape as EntityMasterSection, scoped to the two mapping tables: what each
 * vendor supplies, on the product side and on the material side.
 *
 * The vendor list itself used to be the first tab here and now lives under Entities
 * with the other things a merchant has. These two are relationships rather than
 * things, which is what the section is now named for.
 *
 * WORTH KNOWING: both grids reference a vendor by id and carry no vendor name, so
 * somebody who does not recognise `DUROPACK` has to look it up under Entities. If that
 * becomes a nuisance, a vendor-name column is a correlated subquery in
 * ENTITY_MASTER_CONFIG, the same way each grid already resolves its product or
 * material name.
 */
const TABS: { value: MasterEntityType; label: string }[] = [
    { value: 'VENDOR_PRODUCT_MAPPING', label: 'Vendor Product Mapping' },
    { value: 'VENDOR_MATERIAL_MAPPING', label: 'Vendor Material Mapping' },
    // What each vendor charges, as dated lines: tiers, terms and currencies per item.
    { value: 'VENDOR_PRICE', label: 'Vendor Prices' },
];

const VendorSection: React.FC = () => {
    const [active, setActive] = useState<MasterEntityType>(
        'VENDOR_PRODUCT_MAPPING',
    );

    return (
        <>
            <Group mb="md">
                <SegmentedControl
                    value={active}
                    onChange={(v) => setActive(v as MasterEntityType)}
                    data={TABS}
                    size="xs"
                />
            </Group>
            {/* Keyed so switching tables resets paging, filters and any pending
                edits rather than carrying one table's state onto the other. */}
            <EntityMasterTab key={active} entityType={active} />
        </>
    );
};

export default VendorSection;
